/** @file Premultiplied clear colour (0..1) of a straight `math/color.pack` background word. */
import { color } from '@pose2d/math/color';

const channels: [number, number, number, number] = [0, 0, 0, 0];

/** Writes [round(r·a/255), round(g·a/255), round(b·a/255), a] / 255 into out[0..3] and returns out. */
export function backgroundClear(out: Float32Array, background: number): Float32Array {
  color.unpack(background, channels);
  const alpha = channels[3];
  for (let c = 0; c < 3; c++) out[c] = Math.round((channels[c] ?? 0) * (alpha / 255)) / 255;
  out[3] = alpha / 255;
  return out;
}
